/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  15:30.
*/
<template>
  <div class="feedbackBox">
    <v-title title="反馈成功" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack();"></v-title>
    <div class="closeBox">
      <div class="topImg">
        <img :src="successIcon" alt="">
      </div>
      <p class="success-title">提交成功</p>
      <p class="success-centant">感谢您的反馈，我们会尽快处理您的信息</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackSuccess',
  components: {},

  data () {
    return {
      value: '',
      detailData: {},
      successIcon: require('@/assets/feedback/succeed.png')

    }
  },
  computed: {},
  created () {

  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.fun, false)// false阻止默认事件
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.fun, false)// false阻止默认事件
  },
  methods: {
    fun () {
      this.$router.push({ name: 'clientMap' })
    },
    goBack () {
      this.$router.push({ name: 'clientMap' })
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .feedbackBox{
        height 100%
        .closeBox{
            padding 20px
            text-align center
        }
        .topImg{
            display flex
            align-items center
            justify-content center
            img{
                margin-top 50px
                width 80px
                margin-top 50px
                height 80px
            }
        }
        .success-title{
                text-align center
                margin-top 50px
                font-size 36px
                color #333333
                pading 20px
            }
            .success-centant{
                text-align center
                margin-top 30px
                font-size 30px
                color #333333
            }
    }
</style>
